/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rename_Product_KeyInputs */

const en_rename_product_key = /** @type {(inputs: Rename_Product_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product key`)
};

const de_rename_product_key = /** @type {(inputs: Rename_Product_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktschlüssel`)
};

/**
* | output |
* | --- |
* | "Product key" |
*
* @param {Rename_Product_KeyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rename_product_key = /** @type {((inputs?: Rename_Product_KeyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rename_Product_KeyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_rename_product_key(inputs)
	return en_rename_product_key(inputs)
});